import ENV from "../constants/env-constants";

export async function getUserDetails (userId) {
    const response = await fetch(`${ENV.API_URL}/api/user/${userId}`);
    const data = await response.json();
    return data;
};

export async function getUserDetailsByEmailId (email) {
  console.log(`${ENV.API_URL}/api/user/${email}`);
  const response = await fetch(`${ENV.API_URL}/api/user/email/${email}`);
  const data = await response.json();
  return data;
};

export async function updateUserDetails (userId, firstName, lastName, companyOrOrganization, email, zipcode, country, userType) {
    const response = await fetch(`${ENV.API_URL}/api/user/${userId}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({firstName, lastName, companyOrOrganization, email, zipcode, country, userType})
    });
};

export async function signupUser(userDetails, processType) {
    const { firstName, lastName, companyOrOrganization, email, password, userType, zipcode, country } = userDetails;
    const response = await fetch(`${ENV.API_URL}/api/auth/signup`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ firstName, lastName, companyOrOrganization, email, password, userType, zipcode, country, processType }),
    });
    return response;
}

export async function fetchAllTransactions() {
    const response = await fetch(`${ENV.API_URL}/api/transactions`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json'
        },
      })
    const data = await response.json();
    return data;
}

export async function makeCustomDonation(amount) {
  const response = await fetch(`${ENV.API_URL}/api/donate/custom`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ amount }),
});
return response;
}

export async function createFreeTreeTransaction(userId, email) {
  const response = await fetch(`${ENV.API_URL}/api/freetreetransaction`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ userId, email }),
});
return response;
}